const normalizeBaseUrl = (url) => (url || "").replace(/\/+$/, "");
const DEFAULT_ASSISTANT_BASE = "https://api.dev.theharrispoll.dev/ai-assistant";

export const getAssistantBaseUrl = () => {
  const envBase = import.meta.env.VITE_ASSISTANT_URL;
  let base = envBase || DEFAULT_ASSISTANT_BASE;

  if (typeof window !== "undefined" && window.location.protocol === "https:") {
    base = base.replace(/^http:\/\//i, "https://");
  }

  return normalizeBaseUrl(base);
};

export const buildAssistantUrl = (path = "") => {
  const base = getAssistantBaseUrl();
  const cleaned = String(path || "").replace(/^\/+/, "");
  return `${base}/${cleaned}`;
};

export const buildAssistantHeaders = (extra = {}) => {
  const token = localStorage.getItem("token");
  const headers = { ...extra };
  if (!headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  if (token && !headers.Authorization) {
    headers.Authorization = token.startsWith("Bearer ") ? token : `Bearer ${token}`;
  }
  return headers;
};
